/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * gringotts/v1/services/secret_type_service.proto
 * OpenAPI spec version: version not set
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import * as axios from 'axios';
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';

import type {
  DeleteSecretType200,
  ListSecretTypesParams,
  RpcStatus,
  UpdateSecretTypeBody,
  V1ListSecretTypesResponse,
  V1SecretType,
} from '../../models';

export const listSecretTypes = (
  params?: ListSecretTypesParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ListSecretTypesResponse>> => {
  return axios.default.get(`/api/v1/secretTypes`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getListSecretTypesQueryKey = (params?: ListSecretTypesParams) => {
  return [`/api/v1/secretTypes`, ...(params ? [params] : [])] as const;
};

export const getListSecretTypesQueryOptions = <
  TData = Awaited<ReturnType<typeof listSecretTypes>>,
  TError = AxiosError<RpcStatus>,
>(
  params?: ListSecretTypesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listSecretTypes>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListSecretTypesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listSecretTypes>>> = ({
    signal,
  }) => listSecretTypes(params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listSecretTypes>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListSecretTypesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSecretTypes>>
>;
export type ListSecretTypesQueryError = AxiosError<RpcStatus>;

export function useListSecretTypes<
  TData = Awaited<ReturnType<typeof listSecretTypes>>,
  TError = AxiosError<RpcStatus>,
>(
  params: undefined | ListSecretTypesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listSecretTypes>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSecretTypes>>,
          TError,
          Awaited<ReturnType<typeof listSecretTypes>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListSecretTypes<
  TData = Awaited<ReturnType<typeof listSecretTypes>>,
  TError = AxiosError<RpcStatus>,
>(
  params?: ListSecretTypesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listSecretTypes>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSecretTypes>>,
          TError,
          Awaited<ReturnType<typeof listSecretTypes>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListSecretTypes<
  TData = Awaited<ReturnType<typeof listSecretTypes>>,
  TError = AxiosError<RpcStatus>,
>(
  params?: ListSecretTypesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listSecretTypes>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useListSecretTypes<
  TData = Awaited<ReturnType<typeof listSecretTypes>>,
  TError = AxiosError<RpcStatus>,
>(
  params?: ListSecretTypesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listSecretTypes>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListSecretTypesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const createSecretType = (
  v1SecretType: V1SecretType,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1SecretType>> => {
  return axios.default.post(`/api/v1/secretTypes`, v1SecretType, options);
};

export const getCreateSecretTypeMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSecretType>>,
    TError,
    { data: V1SecretType },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createSecretType>>,
  TError,
  { data: V1SecretType },
  TContext
> => {
  const mutationKey = ['createSecretType'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createSecretType>>,
    { data: V1SecretType }
  > = props => {
    const { data } = props ?? {};

    return createSecretType(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateSecretTypeMutationResult = NonNullable<
  Awaited<ReturnType<typeof createSecretType>>
>;
export type CreateSecretTypeMutationBody = V1SecretType;
export type CreateSecretTypeMutationError = AxiosError<RpcStatus>;

export const useCreateSecretType = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createSecretType>>,
      TError,
      { data: V1SecretType },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createSecretType>>,
  TError,
  { data: V1SecretType },
  TContext
> => {
  const mutationOptions = getCreateSecretTypeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const getSecretType = (
  secretType: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1SecretType>> => {
  return axios.default.get(`/api/v1/secretTypes/${secretType}`, options);
};

export const getGetSecretTypeQueryKey = (secretType?: string) => {
  return [`/api/v1/secretTypes/${secretType}`] as const;
};

export const getGetSecretTypeQueryOptions = <
  TData = Awaited<ReturnType<typeof getSecretType>>,
  TError = AxiosError<RpcStatus>,
>(
  secretType: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSecretType>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetSecretTypeQueryKey(secretType);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSecretType>>> = ({
    signal,
  }) => getSecretType(secretType, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!secretType,
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getSecretType>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSecretTypeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSecretType>>
>;
export type GetSecretTypeQueryError = AxiosError<RpcStatus>;

export function useGetSecretType<
  TData = Awaited<ReturnType<typeof getSecretType>>,
  TError = AxiosError<RpcStatus>,
>(
  secretType: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSecretType>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSecretType>>,
          TError,
          Awaited<ReturnType<typeof getSecretType>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSecretType<
  TData = Awaited<ReturnType<typeof getSecretType>>,
  TError = AxiosError<RpcStatus>,
>(
  secretType: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSecretType>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSecretType>>,
          TError,
          Awaited<ReturnType<typeof getSecretType>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSecretType<
  TData = Awaited<ReturnType<typeof getSecretType>>,
  TError = AxiosError<RpcStatus>,
>(
  secretType: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSecretType>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetSecretType<
  TData = Awaited<ReturnType<typeof getSecretType>>,
  TError = AxiosError<RpcStatus>,
>(
  secretType: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSecretType>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetSecretTypeQueryOptions(secretType, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const deleteSecretType = (
  secretType: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<DeleteSecretType200>> => {
  return axios.default.delete(`/api/v1/secretTypes/${secretType}`, options);
};

export const getDeleteSecretTypeMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSecretType>>,
    TError,
    { secretType: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSecretType>>,
  TError,
  { secretType: string },
  TContext
> => {
  const mutationKey = ['deleteSecretType'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSecretType>>,
    { secretType: string }
  > = props => {
    const { secretType } = props ?? {};

    return deleteSecretType(secretType, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteSecretTypeMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteSecretType>>
>;

export type DeleteSecretTypeMutationError = AxiosError<RpcStatus>;

export const useDeleteSecretType = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteSecretType>>,
      TError,
      { secretType: string },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteSecretType>>,
  TError,
  { secretType: string },
  TContext
> => {
  const mutationOptions = getDeleteSecretTypeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const updateSecretType = (
  secretType: string,
  updateSecretTypeBody: UpdateSecretTypeBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1SecretType>> => {
  return axios.default.patch(
    `/api/v1/secretTypes/${secretType}`,
    updateSecretTypeBody,
    options,
  );
};

export const getUpdateSecretTypeMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSecretType>>,
    TError,
    { secretType: string; data: UpdateSecretTypeBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateSecretType>>,
  TError,
  { secretType: string; data: UpdateSecretTypeBody },
  TContext
> => {
  const mutationKey = ['updateSecretType'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateSecretType>>,
    { secretType: string; data: UpdateSecretTypeBody }
  > = props => {
    const { secretType, data } = props ?? {};

    return updateSecretType(secretType, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateSecretTypeMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateSecretType>>
>;
export type UpdateSecretTypeMutationBody = UpdateSecretTypeBody;
export type UpdateSecretTypeMutationError = AxiosError<RpcStatus>;

export const useUpdateSecretType = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateSecretType>>,
      TError,
      { secretType: string; data: UpdateSecretTypeBody },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateSecretType>>,
  TError,
  { secretType: string; data: UpdateSecretTypeBody },
  TContext
> => {
  const mutationOptions = getUpdateSecretTypeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
